import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { WhatsappLogo, ChatText } from "@phosphor-icons/react";

// One-tap WhatsApp/SMS opt-in. Feeds the SAME policy/consent gate the SI engine uses.
export function ChannelOptIn() {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState("");

  const load = async () => {
    try { setState((await api.get("/ai-sales/consent")).data); } catch { /* silent */ }
  };
  useEffect(() => { load(); }, []);
  if (!state) return null;

  const toggle = async (channel) => {
    const enabled = !state.consent[channel];
    if (enabled && !state.has_phone) return toast.error("Add a phone number to your profile first");
    setBusy(channel);
    try {
      const { data } = await api.post("/ai-sales/consent", { channel, enabled });
      setState((s) => ({ ...s, consent: data.consent }));
      toast.success(enabled ? `You'll hear from us on ${channel === "whatsapp" ? "WhatsApp" : "SMS"}` : "Opted out");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };

  const Item = ({ channel, label, icon: Icon }) => (
    <button data-testid={`optin-${channel}`} onClick={() => toggle(channel)} disabled={busy === channel}
      className={`flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors disabled:opacity-50 ${
        state.consent[channel] ? "border-primary bg-primary text-primary-foreground" : "border-border text-muted-foreground hover:border-primary"}`}>
      <Icon size={15} weight="fill" /> {label} {state.consent[channel] ? "· on" : ""}
    </button>
  );

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 rounded-2xl border border-border bg-card px-4 py-3" data-testid="channel-optin">
      <span className="text-xs font-medium text-muted-foreground">Reach me on:</span>
      <Item channel="whatsapp" label="WhatsApp" icon={WhatsappLogo} />
      <Item channel="sms" label="SMS" icon={ChatText} />
    </div>
  );
}
